<iframe class="w-100 h-100" style="min-height: 30rem;" frameBorder="0" [src]="urlSafe"></iframe>